export const RECEIPT_PAPER_PRESETS = [
  {
    value: '80mm_head_40',
    label: '80mm receipt - 80x40 printer head',
    widthMm: 80,
  },
  {
    value: '80mm_head_50',
    label: '80mm receipt - 80x50 printer head',
    widthMm: 80,
  },
  {
    value: '58mm_roll_35',
    label: '58mm receipt - 58x35 roll',
    widthMm: 58,
  },
  {
    value: '80mm_pos_terminal',
    label: '80mm thermal POS terminal',
    widthMm: 80,
  },
  {
    value: '58mm_pos_terminal',
    label: '58mm thermal POS terminal',
    widthMm: 58,
  },
  {
    value: 'custom',
    label: 'Custom width',
    widthMm: null,
  },
];

export const DEFAULT_RECEIPT_PAPER_PRESET = '80mm_head_40';
export const DEFAULT_RECEIPT_PAPER_WIDTH_MM = 80;

export function getReceiptPaperPreset(presetValue) {
  return (
    RECEIPT_PAPER_PRESETS.find((entry) => entry.value === presetValue) ||
    RECEIPT_PAPER_PRESETS[0]
  );
}

export function normalizeReceiptPaperWidthMm(widthValue, presetValue) {
  const preset = getReceiptPaperPreset(presetValue);
  if (preset.value !== 'custom' && Number.isFinite(preset.widthMm)) {
    return preset.widthMm;
  }

  const numericWidth = Number(widthValue);
  if (Number.isFinite(numericWidth) && numericWidth >= 40 && numericWidth <= 120) {
    return numericWidth;
  }

  if (Number.isFinite(preset.widthMm)) {
    return preset.widthMm;
  }

  return DEFAULT_RECEIPT_PAPER_WIDTH_MM;
}

export function getReceiptPreviewWidthPx(widthMm) {
  const numericWidth = normalizeReceiptPaperWidthMm(widthMm);
  return Math.max(220, Math.min(340, Math.round(numericWidth * 3.8)));
}

export function getReceiptPaperSettings(generalSetting = {}) {
  const receiptPaperPreset =
    generalSetting?.receipt_paper_preset || DEFAULT_RECEIPT_PAPER_PRESET;
  const receiptPaperWidthMm = normalizeReceiptPaperWidthMm(
    generalSetting?.receipt_paper_width_mm,
    receiptPaperPreset
  );

  return {
    receiptPaperPreset,
    receiptPaperWidthMm,
    receiptDialogStyle: {
      width: `${receiptPaperWidthMm}mm`,
      maxWidth: `${receiptPaperWidthMm}mm`,
    },
  };
}
